import { Alert, AlertTitle, AlertDescription } from "@/components/ui/alert";
import { cx } from "class-variance-authority";
import { MessageSquareWarning } from "lucide-react";

export function Disclaimer({ href, className }: { href: string, className?: string }) {
  return (
    <div className={cx(`justify-center mb-4`, className)}>
      <Alert className="border-destructive">
        <MessageSquareWarning strokeWidth={2} size={30} className="stroke-destructive" />
        <AlertTitle className="font-bold ml-2">Make sure to read</AlertTitle>
        <AlertDescription className="ml-2">
          Distribution{" "}
          <a
            href={href}
            target="_blank"
            className="underline"
          >
            Terms & Conditions
          </a>
        </AlertDescription>
      </Alert>
    </div>
  );
}
